import { BusinessProfile } from '@models/business/BusinessProfile'
import { selectBusinessProfileById } from '@store/business/BusinessProfileReducer'
import { useAppSelector } from '@store/hooks'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { ConditionalWrapper } from '@supplement-bacon/react-toolkit/utils'
import { Typography } from 'antd'
import { Link } from 'react-router-dom'

const { Text } = Typography

type Props = SBModelComponent<BusinessProfile> & {
  linkToDetails?: boolean
}

export const BusinessProfileAvatar = ({
  id,
  model,
  linkToDetails = false,
}: Props) => {
  const businessProfile = model
    ? model
    : useAppSelector(selectBusinessProfileById(id!))

  if (!businessProfile) {
    return <></>
  }

  return (
    <ConditionalWrapper
      condition={linkToDetails}
      wrapper={(children) => (
        <Link to={`/users/${businessProfile.appUser}`}>{children}</Link>
      )}
    >
      <Text>
        {businessProfile.lastName} {businessProfile.firstName}
      </Text>
    </ConditionalWrapper>
  )
}

export type BusinessProfileAvatarType = { Avatar: typeof BusinessProfileAvatar }
